import {createService,  updateCommonDetails} from '../services/authService';
var baseUrl = process.env.REACT_APP_BASE_API_URL;
var wrappergateway = process.env.REACT_APP_WRAPPER;
console.log("wrappergateway",wrappergateway)

const serviceHandler = createService();

const processService = {
  ProcessRegistryWebFetch: (data: any) => serviceHandler.handleRequest(`${baseUrl}/ProcessRegistryWebFetch`, data,),
  ProcessRegistryWebAction: (data: any) => serviceHandler.handleRequest(`${baseUrl}/ProcessRegistryWebAction`, data),
  ProcessExportAction: (data: any) => serviceHandler.handleRequest(`${baseUrl}/ProcessExportAction`, data),
};

const blobServices = {
  blobStorage: (data: any, fileType: any) => serviceHandler.handleRequest(`${baseUrl}/BlobStorageWeb`, data, "POST", fileType),
};
const directService = {
  DirectPostServices: (url: any, data: any) => serviceHandler.handleRequest(url, data),
};

export {
  processService,
  blobServices,
  directService
};


//  serviceHandler.handleRequest("https://localhost:7283/magicLabelDetailsFetch", data, "POST", "", "0", 1, ""),